export default function menuGrid() {
  return {
    _id: false,
    type: 'droplet.menuGrid',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sortKey: false,
    sort: 'newest',
    filterText: 'Filters',
    match: 'all',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/menu-grid/droplet.schema.js